import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contex/AuthContext";

import LoginScreen from "./screens/LoginScreen";
import SignupScreen from "./screens/SignupScreen";
import OnboardingScreen from "./screens/OnboardingScreen";
import VerifyEmailScreen from "./screens/VerifyEmailScreen";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import HomeScreen from "./screens/HomeScreen";
import AcademicScreen from "./screens/AcademicScreen";
import TasksScreen from "./screens/TasksScreen";
import NotesScreen from "./screens/NotesScreen";
import FocusScreen from "./screens/FocusScreen";
import FinanceScreen from "./screens/FinanceScreen";
import AppShell from "./components/AppShell";

function ProtectedRoute({ children }) {
  const { user, profile } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user && !user.emailVerified) return <Navigate to="/verify-email" replace />;
  if (user && profile && !profile.school) return <Navigate to="/onboarding" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user && user.emailVerified) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginScreen /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignupScreen /></PublicRoute>} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="/verify-email" element={<VerifyEmailScreen />} />
      <Route path="/onboarding" element={<OnboardingScreen />} />
      <Route path="/" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route index element={<HomeScreen />} />
        <Route path="academic" element={<AcademicScreen />} />
        <Route path="tasks" element={<TasksScreen />} />
        <Route path="notes" element={<NotesScreen />} />
        <Route path="focus" element={<FocusScreen />} />
        <Route path="finance" element={<FinanceScreen />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}